// extracted by mini-css-extract-plugin
export default {"inputFile":"PrescriptionSelect_inputFile__LdINj"};